<template>
  <v-layout>
    <v-dialog v-model="isPromoCodeOpen" width="55%" lazy persistent>
      <v-card>
        <v-flex layout justify-center align-center column pl-4 pr-4 pb-2>
          <v-card-title class="headline pb-1">
            {{ $t('promoCode.dialog.title') }}
          </v-card-title>
          <v-card-text>
            <span style="line-height: 120%" class="grey--text">
              {{ $t('promoCode.dialog.explanation') }}
            </span>

            <div>
              <v-card
                v-for="[pathId, path] in Object.entries(userPaths)"
                :key="pathId"
                style="padding: 20px; cursor: pointer"
                @click="selected = pathId"
                :class="
                  selected == pathId &&
                  !path.isPublished &&
                  (!hasPromoCode(path) || !dateEndInFuture(path))
                    ? 'grey lighten-3'
                    : (hasPromoCode(path) && dateEndInFuture(path)) ||
                      path.isPublished
                    ? 'disabled'
                    : ''
                "
              >
                {{ path.name[locale] }}
                <span
                  v-if="
                    hasPromoCode(path) &&
                    !path.isPublished &&
                    dateEndInFuture(path)
                  "
                  >{{ $t('promoCode.dialog.alreadyUsed') }}</span
                >
                <span v-if="path.isPublished">{{
                  $t('promoCode.dialog.alreadyPublished')
                }}</span>
              </v-card>

              <!--v-card
            @click="selected='new'"
            style="padding: 20px; cursor: pointer;"
            :class="selected=='new' ? 'grey lighten-3' : ''">
              {{$t('promoCode.dialog.newPath')}}
            </v-card-->

              <span
                v-if="promoCodeError"
                style="line-height: 120%"
                class="red--text"
              >
                {{ promoCodeError }}
              </span>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              outline
              class="text-none"
              @click="closeDialog"
            >
              {{ $t('promoCode.dialog.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              class="text-none"
              :disabled="disableConfirmBtn"
              @click="confirmDialog"
            >
              {{ $t('promoCode.dialog.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'PromoCodeDialog',
  components: {},
  props: {
    isPromoCodeOpen: {
      type: Boolean,
      default: false,
    },
    promoCodeValue: {
      type: String,
      default: '',
    },
    userPaths: {
      type: Object,
      default: {},
    },
    promoCodeError: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },

    disableConfirmBtn() {
      const hasSelected = this.selected || !this.selected === '';
      const selectIsNew = this.selected === 'new';
      let hasPromoCode = false;
      let dateEndInFuture = false;
      let isPublished = false;
      if (hasSelected && !selectIsNew) {
        hasPromoCode = this.hasPromoCode(this.userPaths[this.selected]);
        dateEndInFuture = this.dateEndInFuture(this.userPaths[this.selected]);
        isPublished = this.userPaths[this.selected].isPublished;
      }
      return (
        (hasPromoCode && !selectIsNew && dateEndInFuture) ||
        isPublished ||
        !hasSelected
      );
    },
  },
  methods: {
    closeDialog() {
      this.$emit('cancel');
      this.selected = null;
    },
    confirmDialog() {
      this.$emit('confirm', this.selected, this.promoCodeValue);
      this.selected = null;
    },
    hasPromoCode(path) {
      return (
        path.promoCode && path.promoCode.value && path.promoCode.value !== ''
      );
    },
    dateEndInFuture(path) {
      console.log('path', path);
      return path.dateEnd > new Date().getTime();
    },
  },
  watch: {},
};
</script>

<style lang="sass">
.disabled
   opacity: 0.3;
</style>
